var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightRgb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M23.095 46L25.095 46 28.095 43 20.095 43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9fa8da",
    d: "M26.312,44h-4.625C20.209,44,19,42.791,19,41.313V36h10v5.313C29,42.791,27.791,44,26.312,44z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c6bc0",
    d: "M19.005 41.517c.015.778.389 1.466.958 1.921l8.924-1.265C28.953 41.948 29 41.714 29 41.469v-1.331L19.005 41.517zM19 37.559L19 39.559 29 38 29 36z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M24,16h-8.607c-0.677,0-1.158,0.653-0.954,1.298C15.271,19.94,17,26.347,17,34l2,2h5h5l2-2 c0-7.653,1.729-14.06,2.562-16.702C33.765,16.653,33.284,16,32.607,16H24z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0bec5",
    d: "M19 36L24 36 29 36 31 34 17 34z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#cddc39",
    d: "M24,2c-1.912,0-3.567,0.074-5,0.206L21,16h3h3l2-13.794C27.567,2.074,25.912,2,24,2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#8bc34a",
    d: "M29,2.206c-0.622-0.057-1.293-0.101-2.001-0.135L26,16h1h1l2.979-13.508l0.006-0.041 C30.371,2.357,29.723,2.272,29,2.206z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M21.001,2.07C20.293,2.105,19.622,2.148,19,2.206c-0.723,0.066-1.371,0.152-1.985,0.246l0.006,0.041 L20,16h1h1L21.001,2.07z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M32.951,2.832c-0.585-0.143-1.242-0.269-1.966-0.38l-0.006,0.041L28,16h1h2l3.859-12.567 C34.317,3.214,33.687,3.011,32.951,2.832z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2962ff",
    d: "M34.859,3.433L34.859,3.433L31,16h1.764c0.76,0,1.452-0.426,1.789-1.106C35.652,12.681,38,7.851,38,7 C38,5.918,37.466,4.487,34.859,3.433z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M17.021,2.492l-0.006-0.041c-0.724,0.111-1.381,0.237-1.966,0.38 c-0.736,0.18-1.366,0.383-1.908,0.602L17,16h2h1L17.021,2.492z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5722",
    d: "M13.141,3.433C10.534,4.487,10,5.918,10,7c0,0.804,2.35,5.664,3.448,7.889 C13.785,15.572,14.478,16,15.239,16H17L13.141,3.433L13.141,3.433z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightRgb);
export default __webpack_public_path__ + "static/media/lightRgb.0350797b91150ee338f3611a4b9d8ac0.svg";
export { ForwardRef as ReactComponent };